// src/components/ScrollToTop.js
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    const reset = () => {
      // Smooth scroll everywhere possible
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      document.documentElement.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      document.body.scrollTo({ top: 0, left: 0, behavior: "smooth" });

      const wrap = document.querySelector(".app-wrapper");
      if (wrap) {
        wrap.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      }
    };

    reset();
  }, [pathname]);

  return null;
}
